import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { ProductService } from "../../../shared/services/product.service";
import { EcomProd } from '../../../shared/classes/product';
import { MyService } from 'src/app/shared/services/myservice';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-collection-left-sidebar',
  templateUrl: './collection-left-sidebar.component.html',
  styleUrls: ['./collection-left-sidebar.component.scss']
})
export class CollectionLeftSidebarComponent implements OnInit {

  public grid: string = 'col-lg-3';
  @Input() loader: boolean = false;
  gridLoad: number = 12;
  public length: number = 12;
  public layoutView: string = 'grid-view';
  public ecomproducts: EcomProd[] = [];
  public brands: any[] = [];
  public small_Advert: any
  public AdvImg: string
  public colors: any[] = [];
  public size: any[] = [];
  public minPrice: number = 0;
  public maxPrice: number = 2000;
  public min1: number = 0;
  public max1: number = 2000;
  public tags: any[] = [];
  public category: string;
  public prodId: string;
  public pageNo: number = 1;
  public paginate: any = {}; // Pagination use only
  public sortBy: string; // Sorting Order
  public mobileSidebar: boolean = false;
  public loader1: boolean = true;
  filterecomdata = []
  catId: any
  grids: any
  catIdget: Number = 0
  routecatId: number = 0
  ad: any = []
  constructor(private route: ActivatedRoute, private router: Router,
    private viewScroller: ViewportScroller, public productService: ProductService, private myService: MyService, private toastrService: ToastrService) {
    localStorage.removeItem("myApp_gridcol");
    localStorage.removeItem("myApp_Sort");
    localStorage.setItem('mypg', '1');
    this.myService._pageId.next(1);

    this.route.queryParams.subscribe(params => {
      // console.log(params)
      const catid = params.category ? params.category : '0-test';
      this.routecatId = parseInt(catid.split('-')[0], 10) || 0;

      this.myService._catID.subscribe(data => {
        // console.log('Catttttttttttt', data)
        this.catIdget = data
        this.catId = this.catIdget
      })
      this.myService.PageNo.subscribe(data => {
        // console.log('Catttttttttttt',data)
        this.pageNo = data
      })
      if (this.routecatId == this.catId) {
        // console.log('Category ID matches someCondition:', this.someCondition);
      } else {
        this.catId = this.routecatId;
        // console.log('someCondition updated to:', this.someCondition);
      }
      this.brands = params.brand ? params.brand.split(",") : [];
      this.colors = params.color ? params.color.split(",") : [];
      this.size = params.size ? params.size.split(",") : [];
      this.minPrice = params.minPrice ? params.minPrice : this.minPrice;
      this.maxPrice = params.maxPrice ? params.maxPrice : this.maxPrice;
      // console.log(this.minPrice,this.maxPrice)
      this.tags = [...this.brands, ...this.colors, ...this.size]; // All Tags Array
      this.category = params.category ? params.category : null;
      this.sortBy = params.sortBy ? params.sortBy : 'ascending';
      this.pageNo = this.pageNo;
      this.prodId = params.ProdId !== undefined ? params.ProdId : null;
      this.category = params.category ? params.category : 0 || this.catId;
      // console.log(this.category)
      if (this.category == '0') {
        const id = 0
        this.catId = id
      } else {
        this.catId = this.catId
      }

      if (this.filterval == 'a-z') {
        this.sid = 1
      }
      if (this.filterval == 'z-a') {
        this.sid = 2
      }
      if (this.filterval == 'low') {
        this.sid = 3
      }
      if (this.filterval == 'high') {
        this.sid = 4
      }
      if (this.filterval == 'ascending') {
        this.sid = 0
      }

      // console.log(this.catId, this.pageNo, this.length, this.minPrice, this.maxPrice, this.sid)
      this.productService.GetProds(this.catId, this.pageNo, this.length, this.minPrice, this.maxPrice, this.sid, 12)
      this.productService.GetEcomProducts.subscribe(x => {
        // console.log(x)
        this.small_Advert = x['small_Advert']
        this.AdvImg = this.small_Advert[0].imgurl
        this.ad = JSON.parse(this.small_Advert[0].name)
        console.log(this.ad)
        this.ecomproducts = x['product']
        this.ecomproducts.forEach(ele => {
          ele.preDef = JSON.parse(ele.qty_price)
          // ele.non_qtyprice = JSON.parse(ele.non_qty_price)
        })
        // console.log(this.ecomproducts)
        const ecomLength = x['prodtotal']
        this.ecomLength = ecomLength
        this.filterecomdata = this.ecomproducts
        // console.log(this.prodId)
        if (this.prodId != null) {
          this.ecomproducts = this.filterecomdata.filter(x => x.pid == this.prodId)
        }
        const data = localStorage.getItem('myApp_Sort');
        this.value = data || ''
        this.filterecomdata = this.productService.sortEcomProducts(this.ecomproducts, this.value);
        this.ecomproducts = this.ecomproducts.filter(item => item.pri >= this.minPrice && item.pri <= this.maxPrice)
        if (this.ecomproducts.length == 0) {
          this.load = true
        }
        this.paginate = this.productService.getPager(ecomLength, +this.pageNo, this.length);     // get paginate object from service  
      })
      if (params.category)
        this.ecomproducts = this.ecomproducts
    })
    this.fdata = JSON.parse(localStorage.getItem("fav"));
    if (this.fdata != null) {
      this.ecomproducts.forEach(x => {
        if (this.fdata != null) {
          this.fdata.forEach(y => {
            if (x.pid == y.pid) {
              x.fav = true;
            }
          })
        }
      })
    }
  }

  clearCategory() {
    this.catId = 0
    // console.log(this.catId)
    this.router.navigateByUrl(`/shop/collection/left/sidebar?category=${this.catId}&minPrice=0&maxPrice=2000`);
    this.productService.GetProds(this.catId, this.pageNo, this.length, this.minPrice, this.maxPrice, this.sid, 12)
  }

  clearsort() {
    this.filterval = 'ascending'
    this.sortBy = 'ascending'
    this.sortByFilter(this.filterval)
    this.myService._Sortingitem.next(this.sortBy);
  }
  clearGrid() {
    this.grid = 'col-lg-3'
  }
  ClearAll() {
    this.minPrice = 0, this.maxPrice = 2000, this.length = 12
    this.router.navigateByUrl(`/shop/collection/left/sidebar?category=${this.catId}&minPrice=0&maxPrice=2000`);
    this.productService.GetProds(this.catId, this.pageNo, this.length, this.minPrice, this.maxPrice, this.sid, 12)
    this.clearGrid()
    this.clear()
    this.clearsort()
    this.clearCategory()
  }

  clear() {
    this.min1 = 0
    this.max1 = 2000
    this.pageNo = 1
    this.minPrice = 0
    this.maxPrice = 2000
    this.route.queryParams.subscribe(params => {
      const updatedParams = { ...params };
      updatedParams.maxPrice = 0;
      updatedParams.maxDummy = 0;
    });
    this.router.navigateByUrl(`/shop/collection/left/sidebar?category=${this.catId}&minPrice=0&maxPrice=2000`);
    this.productService.GetProds(this.catId, this.pageNo, this.length, this.minPrice, this.maxPrice, this.sid, 12)
  }

  ngOnInit(): void {
    this.myService.PageNo.subscribe(data => {
      this.pageNo = data
    })
    this.productService.GetProds(this.catId, 1, this.length, this.minPrice, this.maxPrice, this.sid, 12)
    localStorage.removeItem("myApp_gridcol");
    this.myService._catID.subscribe(data => {
      this.catIdget = data
      this.catId = this.catIdget
      this.fdata = JSON.parse(localStorage.getItem("fav"));
      if (this.fdata != null) {
        setInterval(() => {
          this.ecomproducts.forEach(x => {
            if (this.fdata != null) {
              this.fdata.forEach(y => {
                if (x.pid == y.pid) {
                  x.fav = true;
                }
              })
            }
          })
        }, 300);
      }
    })
  }

  // Append filter value to Url
  updateFilter(tags: any) {
    // console.log(tags)
    this.pageNo = 1
    tags.page = null; // Reset Pagination
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: tags,
      queryParamsHandling: 'merge', // preserve the existing query params in the route
      skipLocationChange: false  // do trigger navigation
    }).finally(() => {
      this.viewScroller.setOffset([120, 120]);
      this.viewScroller.scrollToAnchor(this.ecomproducts.toString()); // Anchore Link

      if (this.grid === 'col-lg-4' && this.ecomproducts.length < 9 && this.maxPrice <= 2000 && this.minPrice >= 0) {
        this.ecomLength = 1
      }
      if (this.grid === 'col-xl-3 col-md-6' && this.ecomproducts.length < 6 && this.maxPrice <= 2000 && this.minPrice >= 0) {
        this.ecomLength = 1
      }
      if (this.grid === 'col-lg-3' && this.ecomproducts.length < 12 && this.maxPrice <= 2000 && this.minPrice >= 0) {
        this.ecomLength = 1
      }
      if (this.grid === 'col-lg-2' && this.ecomproducts.length < 18 && this.maxPrice <= 2000 && this.minPrice >= 0) {
        this.ecomLength = 1
      }

      this.paginate = this.productService.getPager(this.ecomLength, +this.pageNo, this.length);

      // console.log(this.pageNo)

    });
  }

  filterval: any = 'ascending'
  sid: number = 0
  // SortBy Filter
  sortByFilter(value) {
    this.filterval = value
    this.pageNo = 1
    localStorage.setItem("myApp_Sort", JSON.stringify(this.filterval));
    // console.log(value)
    if (value == 'a-z') {
      this.sid = 1
    }
    if (value == 'z-a') {
      this.sid = 2
    }
    if (value == 'low') {
      this.sid = 3
    }
    if (value == 'high') {
      this.sid = 4
    }
    if (value == 'ascending') {
      this.sid = 0
    }
    this.productService.GetProds(this.catId, this.pageNo, this.length, this.minPrice, this.maxPrice, this.sid, 12)
    this.productService.GetEcomProducts.subscribe(x => {
      this.ecomproducts = x['product']
      this.ecomproducts.forEach(ele => {
        ele.preDef = JSON.parse(ele.qty_price)
      })
      const ecomLength = x['prodtotal']
      this.ecomLength = ecomLength
      this.filterecomdata = this.ecomproducts
      const data = localStorage.getItem('myApp_Sort');
      this.value = data || ''
      this.ecomproducts = this.productService.sortEcomProducts(this.ecomproducts, value);
      if (this.prodId != null) {
        this.ecomproducts = this.filterecomdata.filter(x => x.pid == this.prodId)
      }
      this.filterecomdata = this.productService.sortEcomProducts(this.ecomproducts, this.value.toString());
      this.ecomproducts = this.ecomproducts.filter(item => item.pri >= this.minPrice && item.pri <= this.maxPrice)
      if (this.ecomproducts.length == 0) {
        this.load = false
      }

      this.paginate = this.productService.getPager(this.ecomLength, +this.pageNo, this.length);
      if (this.grid === 'col-lg-4' && this.ecomproducts.length < 9) {
        this.paginate.pages = ["1"]
      }
      if (this.grid === 'col-lg-6' && this.ecomproducts.length < 6) {
        this.paginate.pages = ["1"]
      }
      if (this.grid === 'col-lg-3' && this.ecomproducts.length < 12) {
        this.paginate.pages = ["1"]
      }
      if (this.grid === 'col-lg-2' && this.ecomproducts.length < 18) {
        this.paginate.pages = ["1"]
      }
    })
  }

  // Remove Tag
  removeTag(tag) {
    this.brands = this.brands.filter(val => val !== tag);
    this.colors = this.colors.filter(val => val !== tag);
    this.size = this.size.filter(val => val !== tag);
    let params = {
      brand: this.brands.length ? this.brands.join(",") : null,
      color: this.colors.length ? this.colors.join(",") : null,
      size: this.size.length ? this.size.join(",") : null
    }
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: params,
      queryParamsHandling: 'merge', // preserve the existing query params in the route
      skipLocationChange: false  // do trigger navigation
    }).finally(() => {
      this.viewScroller.setOffset([120, 120]);
      this.viewScroller.scrollToAnchor('products'); // Anchore Link
    });
  }

  // Clear Tags
  removeAllTags() {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {},
      skipLocationChange: false  // do trigger navigation
    }).finally(() => {
      this.viewScroller.setOffset([120, 120]);
      this.viewScroller.scrollToAnchor('products'); // Anchore Link
    });
  }

  // product Pagination
  setPage(page: number) {
    // console.log(page)
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { page: page },
      queryParamsHandling: 'merge', // preserve the existing query params in the route
      skipLocationChange: false  // do trigger navigation
    }).finally(() => {
      this.viewScroller.setOffset([120, 120]);
      this.viewScroller.scrollToAnchor(this.ecomproducts.toString()); // Anchore Link
    });
  }
  load: boolean = false
  gridcol: any = ''
  value: string = 'assending'
  loadgrid: number = 12
  updateGridLayout(value: string) {
    if (this.grid != value) {
      this.load = false
      this.ecomproducts = []
      if (this.loader1) {
        setTimeout(() => { this.loader1 = false; }, 500); // Skeleton Loader
      }
      this.pageNo = 1
      this.grid = value;
      this.gridcol = this.grid
      if (this.grid === 'col-lg-4') {
        this.length = 9
      }
      if (this.grid === 'col-lg-6') {
        this.length = 6
      }
      if (this.grid === 'col-lg-3') {
        this.length = 12
      }
      if (this.grid === 'col-lg-2') {
        this.length = 18
      }
      if (this.filterval == 'a-z') {
        this.sid = 1
      }
      if (this.filterval == 'z-a') {
        this.sid = 2
      }
      if (this.filterval == 'low') {
        this.sid = 3
      }
      if (this.filterval == 'high') {
        this.sid = 4
      }
      if (this.filterval == 'ascending') {
        this.sid = 0
      }
      localStorage.setItem("myApp_gridcol", JSON.stringify(this.length));
      const data = localStorage.getItem('myApp_gridcol');
      this.loadgrid = parseInt(data, 10) || 12;
      this.productService.GetProds(this.catId, this.pageNo, this.length, this.minPrice, this.maxPrice, this.sid, 12)
      this.productService.GetEcomProducts.subscribe(x => {
        // console.log('44444444444444444444444444444444444444444444444444444444')
        this.ecomproducts = x['product']
        this.ecomproducts.forEach(ele => {
          ele.preDef = JSON.parse(ele.qty_price)
        })
        const ecomLength = x['prodtotal']
        this.ecomLength = ecomLength
        this.filterecomdata = this.ecomproducts
        const data = localStorage.getItem('myApp_Sort');
        this.value = data || ''

        if (this.prodId != null) {
          this.ecomproducts = this.filterecomdata.filter(x => x.pid == this.prodId)
        }
        this.filterecomdata = this.productService.sortEcomProducts(this.ecomproducts, this.value.toString());
        this.ecomproducts = this.ecomproducts.filter(item => item.pri >= this.minPrice && item.pri <= this.maxPrice)
        if (this.ecomproducts.length == 0) {
          this.load = true
        }
        this.paginate = this.productService.getPager(this.ecomLength, +this.pageNo, this.length);
        if (this.grid === 'col-lg-4' && this.ecomproducts.length < 9) {
          this.paginate.pages = ["1"]
        }
        if (this.grid === 'col-lg-6' && this.ecomproducts.length < 6) {
          this.paginate.pages = ["1"]
        }
        if (this.grid === 'col-lg-3' && this.ecomproducts.length < 12) {
          this.paginate.pages = ["1"]
        }
        if (this.grid === 'col-lg-2' && this.ecomproducts.length < 18) {
          this.paginate.pages = ["1"]
        }
      })
    }
  }
  ecomLength: any
  // Change Layout View
  updateLayoutView(value: string) {
    this.layoutView = value;
    if (value == 'list-view')
      this.grid = 'col-lg-12';
    else
      this.grid = 'col-xl-3 col-md-6';
  }
  public collapse: boolean = true;
  // Mobile sidebar
  toggleMobileSidebar() {
    this.mobileSidebar = !this.mobileSidebar;
  }
  @Input() onHowerChangeImage: boolean = false;
  public ImageSrc: string
  itemshare() {
    // console.log("its works!", window.location.href);
    let link = 'https://api.whatsapp.com/send?text=' + encodeURIComponent(window.location.href);
    window.open(link, "_blank");
  }

  fdata: any = [];
  saveFav1(item) {
    // console.log(item)
    let st = 1;
    if (localStorage.getItem("fav")) {
      this.fdata.forEach(x => {
        if (x.pid == item.pid) {
          st = 0
        }
      })
      if (this.fdata.includes(item.pid.toString())) {
      }
      else {
      }

      if (st == 1) {
        this.fdata = JSON.parse(localStorage.getItem("fav"))
        this.fdata.push(item)
        localStorage.setItem("fav", JSON.stringify(this.fdata));
        this.toastrService.success('Saved Favourite', item.pname)
      }
      else if (st = 0) {
        this.toastrService.success('Item Already Saved', item.pname)
      }
    }
    else {
      localStorage.setItem("fav", JSON.stringify([item]));
    }
  }
  saveFav(item) {
    // console.log(item);
    if (localStorage.getItem("fav")) {
      var odata = JSON.parse(localStorage.getItem("fav"))
      this.fdata = JSON.parse(localStorage.getItem("fav"));
      // console.log("Already merge data::");
      var isPresent = odata.some(function (el) { return el.pid === item.pid });
      if (isPresent) {
        const objWithIdIndex = odata.findIndex((obj) => obj.pid === item.pid);
        odata.splice(objWithIdIndex, 1);
        localStorage.setItem("fav", JSON.stringify(odata));
        this.toastrService.warning('Removed Favourite', item.pname)
        this.fdata = JSON.parse(localStorage.getItem("fav"));
        this.ecomproducts.forEach(x => {
          if (x.pid == item.pid) {
            x.fav = false
          }
        })
      }
      else {
        odata.push(item)
        localStorage.setItem("fav", JSON.stringify(odata));
        this.toastrService.success('Saved Favourite', item.pname)
        this.fdata = JSON.parse(localStorage.getItem("fav"));
        this.ecomproducts.forEach(x => {
          this.fdata.forEach(y => {
            if (x.pid == y.pid) {
              x.fav = true;
            }
          })
        })
      }
      this.fdata = JSON.parse(localStorage.getItem("fav"));
    }
    else {
      localStorage.setItem("fav", JSON.stringify([item]));
      this.toastrService.success('Saved Favourite', item.pname)
      var odata = JSON.parse(localStorage.getItem("fav"))
      this.fdata = JSON.parse(localStorage.getItem("fav"));
      this.ecomproducts.forEach(x => {
        this.fdata.forEach(y => {
          if (x.pid == y.pid) {
            x.fav = true;
          }
        })
      })
    }
  }

  gridlistviews: boolean = false
  griddoubleviews: boolean = true
  Grid2view() {
    this.gridlistviews = false
    this.griddoubleviews = true
  }
  Listview() {
    this.gridlistviews = true
    this.griddoubleviews = false
  }
}
